/** set of helper function regarding IPs */
var IP = {
    v4: {
        /** returns an array of 4 * 8 bit numbers or null if invalid */
        parse(value) {
            var parts = value.split(".");
            if (parts.length !== 4) {
                return null;
            }

            var bytes = parts.map(function (part) {
                var byte = parseInt(part, 10);
                if (isNaN(byte) || byte < 0 || byte > 255) {
                    return null;
                }
                return byte;
            });

            if (
                bytes.some(function (b) {
                    return b === null;
                })
            ) {
                return null;
            }

            return bytes;
        },

        hasHostBits(ipBytes, mask) {
            var ipAsInt = ipBytes.reduce(function (acc, byte) {
                return (acc << 8) + byte;
            }, 0);

            var maskAsInt = mask === 0 ? 0 : ~((1 << (32 - mask)) - 1) >>> 0;

            return (ipAsInt & ~maskAsInt) !== 0;
        },
    },

    v6: {
        /** returns an array of 8 * 16 bit numbers or null if invalid */
        parse(value) {
            var parts = value.split("::");
            var head = parts[0] ? parts[0].split(":") : [];
            var tail = parts[1] ? parts[1].split(":") : [];

            var missing = 8 - (head.length + tail.length);
            if (parts.length === 1) {
                missing = 0;
            }

            var words = [];
            for (let i = 0; i < head.length; i++) {
                words.push(parseInt(head[i], 16));
            }
            for (let i = 0; i < missing; i++) {
                words.push(0);
            }
            for (let i = 0; i < tail.length; i++) {
                words.push(parseInt(tail[i], 16));
            }

            if (
                words.length !== 8 ||
                words.some(function (n) {
                    return isNaN(n) || n < 0 || n > 0xffff;
                })
            ) {
                return null;
            }

            return words;
        },

        /** returns whether the given ipv6 address has bits set right to the given mask */
        hasHostBits(ipWords, mask) {
            var fullWords = Math.floor(mask / 16);
            var partialBits = mask % 16;

            for (var i = fullWords + (partialBits > 0 ? 1 : 0); i < 8; i++) {
                if (ipWords[i] !== 0) {
                    return true;
                }
            }

            if (partialBits > 0) {
                var maskWord = ~((1 << (16 - partialBits)) - 1) & 0xffff;
                if ((ipWords[fullWords] & ~maskWord) !== 0) {
                    return true;
                }
            }

            return false;
        },
    },
};

function passwordMatch(value, key, params, formValues) {
    if (formValues[params.passwordFieldName] !== formValues["retype_password"]) {
        return { key: key };
    }
    return {};
}

function counter(condition, input) {
    return input.filter(condition).length;
}

function isUpperCase(element) {
    return element.toUpperCase() === element;
}

function isLowerCase(element) {
    return !isUpperCase(element);
}

function isSpecial(element) {
    return "~!@#$%^&*()_+-.=?<>,:;{}|".indexOf(element) !== -1;
}
function isNumber(element) {
    return "0123456789".indexOf(element) !== -1;
}

function requiredCharacter(value, key, params) {
    if (params.enableEmptyAnyway && value === "") return {};

    var keyFunctionMapping = {
        insufficient_lowercase_chars: isLowerCase, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_uppercase_chars: isUpperCase, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_special_chars: isSpecial, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
        insufficient_number_chars: isNumber, // jscs:ignore requireCamelCaseOrUpperCaseIdentifiers
    };
    if (!Object.prototype.hasOwnProperty.call(keyFunctionMapping, key)) {
        throw new Error("Unknown key: ", key);
    }
    var charArray = value.split("");
    if (params.min !== null && params.min > 0) {
        if (counter(keyFunctionMapping[key], charArray) < params.min) return { key: key, min: params.min };
    }
    return {};
}

// This 'validator' checks if the value is -1. If it is, it returns its key to show invalid format error
function refreshTokenDurationFormat(value, key) {
    if (value === -1) {
        return { key: key };
    }

    return {};
}

// Checks if an interval is within a range. If not, params.min_text_value and params.max_text_value are returned
// along with the error key to show min and max in a custom format
function intervalRange(value, key, params) {
    if (value < params.min || value > params.max) {
        return { key: key, min: params.min_text_value, max: params.max_text_value };
    }

    return {};
}

function requiredIfFieldEqualsTo(value, key, params, formValues) {
    var fieldName = params.field;
    var fieldValue = params.value;

    var formValue = formValues[fieldName];

    if (formValue === fieldValue && (value === null || value === undefined || value.length === 0)) {
        return { key: key };
    }

    return {};
}

function cidr(value, key) {
    if (typeof value !== "string") {
        return { key: key };
    } else if (!value) {
        return { key: key };
    }

    var parts = value.split("/");
    if (parts.length !== 2) {
        return { key: key };
    }

    var ipPart = parts[0];
    var maskPart = parts[1];

    var ipv4 = IP.v4.parse(ipPart);
    var ipv6 = IP.v6.parse(ipPart);

    if (!ipv4 && !ipv6) {
        return { key: key };
    }

    var mask = parseInt(maskPart, 10);
    if (isNaN(mask) || mask < 0) {
        return { key: key };
    }

    if (ipv4) {
        if (mask > 32) {
            return { key: key };
        }

        if (IP.v4.hasHostBits(ipv4, mask)) {
            return { key: key };
        }
    } else {
        if (mask > 128) {
            return { key: key };
        }

        if (IP.v6.hasHostBits(ipv6, mask)) {
            return { key: key };
        }
    }

    return {};
}

function cidrList(value, key) {
    if (value === null || value === undefined) {
        return {};
    }

    if (!Array.isArray(value)) {
        return { key: key };
    }

    for (var i = 0; i < value.length; i++) {
        var cidrValue = value[i];
        if (cidr(cidrValue, key).key) {
            return { key: key };
        }
    }
    return {};
}

module.exports = {
    passwordMatch: passwordMatch,
    requiredCharacter: requiredCharacter,
    intervalRange: intervalRange,
    refreshTokenDurationFormat: refreshTokenDurationFormat,
    requiredIfFieldEqualsTo: requiredIfFieldEqualsTo,
    cidr: cidr,
    cidrList: cidrList,
};
